import { defineComponent } from "vue";

export default defineComponent({
  name: "Dashboard",
  props: {},
  components: {}
  //   setup(props) {},
});
